import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, makeStyles } from '@material-ui/core';

import { S3ObjectInput, useUpdateUserProfileMutation } from 'api';
import { AspectRatios } from 'types/app';
import { IUploader, UploadDialog, Uploader, UploadInput, UserAvatar } from 'components';
import { useCurrentUser, useNotify } from 'hooks';

const useStyles = makeStyles(theme => ({
  uploadImage: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(3),
  },
}));

const ProfileImageUpload: FC = () => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const notify = useNotify();
  const classes = useStyles();
  const { mutate } = useUpdateUserProfileMutation({
    onError: notify.mutationError,
  });

  function handleSave(image: S3ObjectInput) {
    const variables = {
      data: { id: currentUser.id, image },
    };

    mutate({ ...variables });
  }

  return (
    <Grid container alignItems="center" className={classes.uploadImage}>
      <Grid item>
        <Uploader onSave={handleSave}>
          {(uploaderProps: IUploader) => (
            <Fragment>
              <UploadInput onUpload={uploaderProps.onUpload}>
                <Grid container alignItems="center">
                  <Grid item>
                    <UserAvatar user={currentUser} size={50} />
                  </Grid>
                  <Grid item xs>
                    <Button component="span">{t('user:uploadImage')}</Button>
                  </Grid>
                </Grid>
              </UploadInput>
              <UploadDialog
                i18nKeyTitle="user:yourProfileImage"
                i18nKeyReplace="components:replaceImage"
                aspectRatio={AspectRatios.square}
                {...uploaderProps}
              />
            </Fragment>
          )}
        </Uploader>
      </Grid>
    </Grid>
  );
};

export default ProfileImageUpload;
